/*
 * @右侧内容重构
 * @Date:   2017-11-30 15:29:05
 * @Author:   fang.lijuan
 */

'use strict';
angular.module('xinhuaShareDetailModule', []).directive('xinhuaShareDetail', [
    '$state',
    '$location',
    '$filter',
    '$timeout',
    '$stateParams',
    'trsHttpService',
    'trsspliceString',
    'resourceCenterService',
    'modalDialog',
    'resCtrModalService',
    'storageListenerService',
    '$q',
    function(
        $state,
        $location,
        $filter,
        $timeout,
        $stateParams,
        trsHttpService,
        trsspliceString,
        resourceCenterService,
        modalDialog,
        resCtrModalService,
        storageListenerService,
        $q
    ) {
        return {
            scope: {
                rebuildData: '=',
            },
            restrict: 'AE',
            templateUrl: './resourceCenter/XinhuaNews/quickPreview/detail/detail_tpl.html',
            replace: true,
            link: function(scope, iElm, iAttrs, controller) {
                initStatus();
                initData();
                /**
                 * [initStatus description]状态初始化
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        currModule: 'xhsg',
                    };
                    scope.basicParams = {
                        channelName: scope.status.currModule,
                        typeName: $stateParams.typename,
                        nodeId: $stateParams.nodeid,
                    };
                    scope.detailData = [];
                }
                /**
                 * [initData description]初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    if (angular.isDefined(scope.rebuildData)) {
                        requestData();
                    }
                }
                /**
                 * [getQuInfo description]获取取稿人信息（初始化，取稿之后调用）
                 * @return {[type]} [description]
                 */
                function getQuInfo() {
                    scope.detailData.quInfos = [];
                    var params = {
                        serviceid: 'mlf_bigdataexchange',
                        methodname: 'queryFlagList',
                        guid: scope.rebuildData.guid,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        for (var j = 0; j < data.QU.length; j++) {
                            var fromtemp = data.QU[j];
                            var intotemp = {
                                COMPANY: fromtemp.COMPANY,
                                OPERUSER: fromtemp.OPERUSER, //fromtemp.OPERUSER.split("-")[1]
                            };
                            scope.detailData.quInfos.push(intotemp);
                        }
                        scope.detailData.quInfos = $filter('unique')(scope.detailData.quInfos, 'OPERUSER');
                        scope.detailData.quInfoStr = '';
                        if (scope.detailData.quInfos.length > 1) {
                            for (var k = 0; k < scope.detailData.quInfos.length - 1; k++) {
                                scope.detailData.quInfoStr += scope.detailData.quInfos[k].OPERUSER + ';';
                            }
                            scope.detailData.quInfoStr += scope.detailData.quInfos[scope.detailData.quInfos.length - 1].OPERUSER;
                        } else if (scope.detailData.quInfos.length == 1) {
                            scope.detailData.quInfoStr = scope.detailData.quInfos[0].OPERUSER;
                        }
                    });
                }
                /**
                 * [requestData description]获取数据
                 * @return {[type]} [description]
                 */
                function requestData() {
                    var params = {
                        typeid: 'zyzx',
                        serviceid: 'xhsg',
                        modelid: 'detailData',
                        guid: scope.rebuildData.guid,
                        indexName: scope.rebuildData.indexName,
                    };
                    scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        if (data.result == 'success') {
                            scope.detailData = data.content[0];
                            //var keywords = scope.detailData.ZB_KEYWORDS5_CHAR;
                            scope.detailData.keywordsArr = scope.detailData.KEYWORDS == '' ? [] : scope.detailData.KEYWORDS.split(';');
                            getQuInfo();
                        }
                    });
                }
                /**
                 * [openTakeDraftModal description]取稿
                 * @return {[type]} [description]
                 */
                scope.openTakeDraftModal = function() {
                    var params = {
                        serviceid: 'mlf_bigdataexchange',
                        methodname: 'fetch',
                        guid: scope.rebuildData.guid,
                    };
                    params = angular.extend(params, scope.basicParams);
                    var modalInstance = resCtrModalService.fullTakeDraft(params, false, [scope.rebuildData]);
                    modalInstance.result.then(
                        function(data) {
                            takeDraftDownloadImgs(data).then(function() {
                                getQuInfo();
                                storageListenerService.addListenerToResource('takeDraft');
                            });
                        },
                        function() {
                            getQuInfo();
                            storageListenerService.addListenerToResource('takeDraft');
                        }
                    );
                };
                /**
                 * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
                 * @param  {[type]} data [description]
                 * @return {[type]}      [description]
                 */
                function takeDraftDownloadImgs(data) {
                    var deferred = $q.defer();
                    var needDownloadImg = false;
                    for (var i = 0; i < data.REPORTS.length; i++) {
                        if (data.REPORTS[i].PICERROR == 1) {
                            needDownloadImg = true;
                            break;
                        }
                    }
                    if (needDownloadImg) {
                        resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                            deferred.resolve();
                        });
                    } else {
                        deferred.resolve();
                    }
                    return deferred.promise;
                }
                //个人素材(稿件批量添加到个人素材)
                scope.creationAxis = function() {
                    var params = {
                        typeid: 'zyzx',
                        serviceid: 'mlf_bigdataexchange',
                        methodname: 'batchPersonalMaterial',
                        channelName: scope.status.currModule, //栏目名称全拼结构
                        PersonalMaterialId: 0, //所属文件夹ID，默认根节点（0）
                        indexName: scope.rebuildData.indexName,
                        guid: scope.rebuildData.guid,
                    };
                    scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        modalDialog.alertType('添加成功', '', 'success', false, function() {});
                    });
                };
                // 收藏
                scope.collect = function() {
                    var params = {
                        serviceid: 'mlf_bigdataexchange',
                        methodname: 'collect',
                        guid: scope.rebuildData.guid,
                    };
                    params.indexName = scope.rebuildData.indexName;
                    params = angular.extend(params, scope.basicParams);
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        modalDialog.alertType('收藏成功!', '', 'success', false, '');
                    });
                };
                /**
                 * [plainView description] 返回 普通视图
                 * @return {[type]} [description]
                 */
                scope.plainView = function() {
                    $state.go('front.resourcectrl.xinhua.resource', $stateParams);
                };
            },
        };
    },
]);
